import { Box, Button, Typography } from "@mui/material";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { IconComponent } from "src/shared/components";
import { Can } from "src/shared/lib/rback/Can";
import { EIconNames } from "src/shared/types/iconNames";
import { useLazyExportFinalReportQuery } from "../api/api";
import { buildExportFinalReportQuery } from "./helpers/buildExportFinalReportQuery";

export function TableHeader() {
  const [isExporting, setIsExporting] = useState(false);
  const [exportFinalReport] = useLazyExportFinalReportQuery();
  const [searchParams] = useSearchParams();

  const handleExportFinalReport = async () => {
    const partner_id = searchParams.get("partner_id");
    const agency = searchParams.get("agency");
    const report_month = searchParams.get("report_month");
    const FILE_NAME = "Итоговый_отчет_по_бонусам_Партнеров_";

    const queryParams = buildExportFinalReportQuery(
      partner_id,
      agency,
      report_month,
    );

    try {
      setIsExporting(true);

      const result = await exportFinalReport(queryParams);

      if (result.data) {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        const resultFileName = `${FILE_NAME}${report_month}`;
        link.href = url;
        link.setAttribute("download", `${resultFileName}.csv`); // Имя файла
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      enqueueSnackbar("Произошла ошибка", {
        variant: "error",
        handleClose: closeSnackbar,
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 3,
      }}
    >
      <Typography variant="h6">Итоговый отчет по бонусам Партнеров</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 3,
          ml: "auto",
        }}
      >
        <Can perform="partners.final-report.export">
          <Button
            onClick={handleExportFinalReport}
            startIcon={<IconComponent iconname={EIconNames.DOWNLOAD} />}
            variant="outlined"
            disabled={isExporting}
          >
            Экспорт выплат
          </Button>
        </Can>
      </Box>
    </Box>
  );
}
